<div class="px-4 md:px-6 mt-4" [ngClass]="{'p-2': isModal}">
    <div class="max-w-6xl mx-auto mb-4">
        <app-page-breadcrumb [pageInfo]="pageInfo" [isModal]="isModal"></app-page-breadcrumb>
    </div>
    <div class="max-w-6xl mx-auto bg-white rounded-xl shadow-sm border border-[#dce4ef] p-6">
        <app-form-generator #basicForm (onChangeEvent)="onChange($event)" [dynamicValidator]="dynFormData"
            [formData]="basicFormData">
        </app-form-generator>
        <div class="mt-6 flex justify-center gap-3">
            <p-button [loading]="loading" icon="pi pi-check-circle" (click)="onSubmit()" severity="success"
                [raised]="true" [label]="loading && !patientId
                    ? 'Saving'
                    : loading && patientId
                    ? 'Updating'
                    : patientId
                    ? 'Update'
                    : 'Save'">
            </p-button>
            <p-button label="Close" severity="danger" [raised]="true" (click)="close()">
            </p-button>

        </div>
    </div>
</div>

<ng-template #searchResult>
    <div class="dropdownInput shadow-lg p-3 mb-5 bg-white rounded">
        <div class="dropdown-result">
            <div class="card-title"><a href="javascript:void(0)">Patient Result with the Mobile No</a></div>
            <div class="table-responsive ">
                <table class="table table-hover spacing8">
                    <tbody>
                        <ng-container *ngIf="patientList.length else noRecordSearch">
                            <tr *ngFor="let a of patientList" class="cursor-pointer w-100">
                                <td>{{a?.patient_id }}</td>
                                <td>{{a?.f_name ||a?.patient_fullName}} {{a?.l_name}}</td>
                                <td>{{a?.total_amount || a?.mobile_no}}</td>
                                <td>{{a?.address || a?.statusName}}</td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #noRecordSearch>
    <tr>
        <td colspan="4">
            <h5>No Matched Data</h5>
        </td>
    </tr>
</ng-template>